module.exports = __webpack_public_path__ + "media/images/guide-8t-2c794ca3291f8a05fd9517f91d590f3f.png";